import { Directive } from "@angular/core";

import { ModalRef } from "@lantern/app/core/utils/modals/modal-ref";

@Directive()
export abstract class ModalComponent<Response> {
  constructor(private modalRef: ModalRef<Response>) {}

  close(response: Response): void {
    this.modalRef.close(response);
  }

  dismiss(err: any): void {
    this.modalRef.dismiss(err);
  }
}
